module.exports = __webpack_public_path__ + "static/media/mri-approach.abdba4d2.jpg";